"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tipping = exports.ThumbFeedback = exports.HelpfulQuestion = exports.HelpfulnessSurvey = exports.ResourceUserFeedback = exports.UserFeedbackModal = exports.DEFAULT_TIPPING_CONFIG = void 0;
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const UserFeedbackModal_1 = __importDefault(require("./components/UserFeedbackModal"));
const ResourceUserFeedback_1 = __importDefault(require("./components/ResourceUserFeedback"));
const HelpfulnessSurvey_1 = __importDefault(require("./components/HelpfulnessSurvey"));
const HelpfulQuestion_1 = __importDefault(require("./components/HelpfulQuestion"));
const ThumbFeedback_1 = __importDefault(require("./components/ThumbFeedback"));
const Tipping_1 = __importDefault(require("./components/Tipping"));
// Tipping config
// These values can be overridden by adjusting the `buoy-interview-tipping-module-copy` feature flag
exports.DEFAULT_TIPPING_CONFIG = {
    button_text: "Submit",
    default_tip_values: [1, 3, 5],
    description: "Our tiny team has big ideas for healthcare. Help us rise to the challenge with a tip. 100% of tips go into new tech.",
    placement: "end_of_interview",
    title: "Loving Buoy? Let us know with a tip.",
    variant_name: "control",
    background_color: "",
};
exports.UserFeedbackModal = (0, common_buoy_theme_1.withTheme)(UserFeedbackModal_1.default);
exports.ResourceUserFeedback = (0, common_buoy_theme_1.withTheme)(ResourceUserFeedback_1.default);
exports.HelpfulnessSurvey = (0, common_buoy_theme_1.withTheme)(HelpfulnessSurvey_1.default);
exports.HelpfulQuestion = (0, common_buoy_theme_1.withTheme)(HelpfulQuestion_1.default);
exports.ThumbFeedback = (0, common_buoy_theme_1.withTheme)(ThumbFeedback_1.default);
exports.Tipping = (0, common_buoy_theme_1.withTheme)(Tipping_1.default);
//# sourceMappingURL=index.js.map